<template>
  <!-- HEADER -->
  <div class="top-bar">
    <button class="btn-back" @click="goBack">
      <i class="material-icons">arrow_back</i>
    </button>
    <h1>Mis Favoritos</h1>
  </div>

  <div class="favoritos-container">

    <!-- SKELETON LOADER -->
    <div v-if="loading" class="list">
      <div v-for="n in 6" :key="n" class="card">
        
        <div class="thumb skeleton"></div>

        <div class="content">
          <div class="skeleton skeleton-text category"></div>
          <div class="skeleton skeleton-text title"></div>
          <div class="skeleton skeleton-text line"></div>
          <div class="skeleton skeleton-text line short"></div>
          <div class="skeleton skeleton-text date"></div>
        </div>

      </div>
    </div>

    <!-- SIN FAVORITOS -->
    <div v-else-if="favorites.length === 0" class="empty">
      <img src="/undraw_spread-love_0ekp.png" alt="" class="undraw_spread">
      <p>No tienes artículos en favoritos 😢</p>
    </div>

    <!-- LISTA REAL -->
    <div v-else class="list">
      <div 
        v-for="post in favorites" 
        :key="post.id" 
        class="card"
        @click="goToPost(post)"
      >
        <img 
          :src="getImage(post.image)" 
          class="thumb"
          @error="$event.target.src='/noimagen.png'"
        />

        <div class="content">
          <h6 class="content-category-title">
            {{ post.category.name }}
          </h6>

          <h3>{{ post.title }}</h3>
          <p>{{ post.extract }}</p>

          <span class="date">
            {{ formatDate(post.created_at) }}
          </span>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '../../services/api'

const router = useRouter()

const favorites = ref([])
const loading = ref(true)


onMounted(() => {
  loadFavorites()
})

const loadFavorites = async () => {
  try {
    const response = await api.get('/favorites')
    favorites.value = response.data?.data?.data || []
  } catch (error) {
    console.error('Error cargando favoritos:', error)
    favorites.value = []
  } finally {
    loading.value = false
  }
}

const goToPost = (post) => {
  router.push(`/noticia/${post.slug}`)
}

const getImage = (img) => {
  if (!img) return '/noimagen.png'
  if (img.startsWith('http')) return img
  return `https://portal.jlhvision.com/posts/${img}`
}

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

const goBack = () => {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push('/mizona')
  }
}
</script>

<style scoped>
.favoritos-container {
  padding: 20px;
}

/* HEADER */
.top-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
}

/* BOTÓN */
.btn-back {
  background: none;
  border: none;
  cursor: pointer;
}

.btn-back i {
  font-size: 26px;
  color: #00144a;
}

.top-bar h1 {
  font-size: 18px;
}

/* CARD */
.card {
  display: flex;
  gap: 12px;
  margin-bottom: 15px;
}

/* IMPORTANTE 👇 */
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* IMAGEN */
.thumb {
  width: 110px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
}

/* TEXTOS */
.content h3 {
  font-size: 14px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.content p {
  font-size: 12px;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.content-category-title {
  color: #a50000;
  font-size: 11px;
  margin-bottom: 3px;
}

.date {
  font-size: 11px;
  color: #999;
}

/* EMPTY */
.empty {
  text-align: center;
  margin-top: 40px;
  color: #777;
}

/* ========================= */
/* SKELETON 🔥 */
/* ========================= */

.skeleton {
  position: relative;
  overflow: hidden;
  background: #e5e7eb;
  border-radius: 6px;
}

/* shimmer */
.skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.6),
    transparent
  );
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}

/* TEXT SKELETON */
.skeleton-text {
  display: block;
  width: 100%;
  height: 12px;
  margin-bottom: 6px;
}

/* variantes */
.skeleton-text.category {
  width: 40%;
  height: 10px;
}

.skeleton-text.title {
  width: 95%;
  height: 14px;
}

.skeleton-text.line {
  width: 100%;
}

.skeleton-text.line.short {
  width: 70%;
}

.skeleton-text.date {
  width: 30%;
  height: 10px;
}

/* IMAGE */
.thumb.skeleton {
  width: 110px;
  height: 80px;
}

.undraw_spread{
  width: 100%;
  display: block;
  margin-bottom: 50px;
}
</style>


